/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Preview_DownloadedInputs */

const en_image_export_preview_downloaded = /** @type {(inputs: Image_Export_Preview_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview downloaded successfully`)
};

const fr_image_export_preview_downloaded = /** @type {(inputs: Image_Export_Preview_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previsualisation telechargee avec succes`)
};

const de_image_export_preview_downloaded = /** @type {(inputs: Image_Export_Preview_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschau erfolgreich heruntergeladen`)
};

const it_image_export_preview_downloaded = /** @type {(inputs: Image_Export_Preview_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anteprima scaricata correttamente`)
};

const ru_image_export_preview_downloaded = /** @type {(inputs: Image_Export_Preview_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительная версия успешно загружена.`)
};

const es_image_export_preview_downloaded = /** @type {(inputs: Image_Export_Preview_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista previa descargada exitosamente`)
};

const zh_cn2_image_export_preview_downloaded = /** @type {(inputs: Image_Export_Preview_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预览版下载成功`)
};

const ja_image_export_preview_downloaded = /** @type {(inputs: Image_Export_Preview_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレビューが正常にダウンロードされました`)
};

const hi_image_export_preview_downloaded = /** @type {(inputs: Image_Export_Preview_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूर्वावलोकन सफलतापूर्वक डाउनलोड हो गया`)
};

const pt_pt2_image_export_preview_downloaded = /** @type {(inputs: Image_Export_Preview_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pré-visualização baixada com sucesso.`)
};

/**
* | output |
* | --- |
* | "Preview downloaded successfully" |
*
* @param {Image_Export_Preview_DownloadedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_preview_downloaded = /** @type {((inputs?: Image_Export_Preview_DownloadedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Preview_DownloadedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_preview_downloaded(inputs)
	if (locale === "de") return de_image_export_preview_downloaded(inputs)
	if (locale === "it") return it_image_export_preview_downloaded(inputs)
	if (locale === "ru") return ru_image_export_preview_downloaded(inputs)
	if (locale === "es") return es_image_export_preview_downloaded(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_preview_downloaded(inputs)
	if (locale === "ja") return ja_image_export_preview_downloaded(inputs)
	if (locale === "hi") return hi_image_export_preview_downloaded(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_preview_downloaded(inputs)
	return en_image_export_preview_downloaded(inputs)
});